/** Unisce nomi di classe ignorando i valori falsi. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ')
}
